import React, { useContext } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { UserContext } from "../state/UserContext";
import { Layout, Typography } from "antd";
import Navbar from "./templates/Navbar";
import Home from "./home/Home";
import Movies from "./home/Movies";
import Games from "./home/Games";
import MovieDetail from "./home/components/MovieDetail";
import GameDetail from "./home/components/GameDetail";
import Login from "./home/Login";
import Register from "./home/Register";
import { NavContext } from "../state/NavContext";
import Dashboard from "./admin/Dashboard";
import Sidebar from "./templates/Sidebar";
import AllMovies from "./admin/AllMovies";
import AllGames from "./admin/AllGames";
import ChangePassword from "./admin/ChangePassword";
import FormMovie from "./admin/FormMovie";
import FormGame from "./admin/FormGame";
import NotFound from "./templates/NotFound";

const { Content, Footer } = Layout;

const Routes = () => {
  const { user } = useContext(UserContext);
  const { isSideBarActive } = useContext(NavContext);

  const PrivateRoute = ({ ...rest }) => {
    if (user) {
      return <Route {...rest} />;
    } else {
      return <Redirect to="/login" />;
    }
  };

  const LoginRoute = ({ ...rest }) => {
    if (user) {
      return <Redirect to="/" />;
    } else {
      return <Route {...rest} />;
    }
  };

  const renderPublicTemplate = () => {
    return (
      <Layout>
        <Navbar />
        <Content
          className="site-layout"
          style={{ padding: "0 50px", marginTop: 88 }}
        >
          <div className="site-layout-background">
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/movies">
                <Movies />
              </Route>
              <Route exact path="/games">
                <Games />
              </Route>
              <LoginRoute exact path="/login">
                <Login />
              </LoginRoute>
              <LoginRoute exact path="/register">
                <Register />
              </LoginRoute>
              <Route exact path="/movies/detail/:id">
                <MovieDetail />
              </Route>
              <Route exact path="/games/detail/:id">
                <GameDetail />
              </Route>

              <PrivateRoute exact path="/admin/dashboard">
                <Dashboard />
              </PrivateRoute>
              <PrivateRoute exact path="/admin/dashboard">
                <Dashboard />
              </PrivateRoute>

              <PrivateRoute exact path="/admin/add-movie">
                <FormMovie sideIndex="add-movie" />
              </PrivateRoute>
              <PrivateRoute exact path="/admin/edit-movie/:id">
                <FormMovie sideIndex="edit-movie" />
              </PrivateRoute>
              <PrivateRoute exact path="/admin/all-movies">
                <AllMovies />
              </PrivateRoute>

              <PrivateRoute exact path="/admin/add-game">
                <FormGame sideIndex="add-game" />
              </PrivateRoute>
              <PrivateRoute exact path="/admin/edit-game/:id">
                <FormGame sideIndex="edit-game" />
              </PrivateRoute>
              <PrivateRoute exact path="/admin/all-games">
                <AllGames />
              </PrivateRoute>

              <PrivateRoute exact path="/admin/change-password">
                <ChangePassword />
              </PrivateRoute>

              <Route exact component={NotFound} />
            </Switch>
          </div>
        </Content>
        <Footer
          style={{
            textAlign: "center",
            background: "#001529",
            color: "white",
            marginTop: "24px",
          }}
        >
          Movie Game Pedia ©2021 Created by{" "}
          <Typography.Link target="_blank" href="https://github.com/nadahasnim">
            Nada Hasni Muhammad
          </Typography.Link>
        </Footer>
      </Layout>
    );
  };

  const renderPrivateTemplate = () => {
    return (
      <Layout>
        <Navbar />
        <Layout hasSider={true} style={{ marginTop: 64 }}>
          <Sidebar />
          <Layout>
            <Content
              className="site-layout-background"
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              <Switch>
                <Route exact path="/">
                  <Home />
                </Route>
                <Route exact path="/movies">
                  <Movies />
                </Route>
                <Route exact path="/games">
                  <Games />
                </Route>
                <LoginRoute exact path="/login">
                  <Login />
                </LoginRoute>
                <LoginRoute exact path="/register">
                  <Register />
                </LoginRoute>
                <Route exact path="/movies/detail/:id">
                  <MovieDetail />
                </Route>
                <Route exact path="/games/detail/:id">
                  <GameDetail />
                </Route>

                <PrivateRoute exact path="/admin/dashboard">
                  <Dashboard />
                </PrivateRoute>

                <PrivateRoute exact path="/admin/add-movie">
                  <FormMovie sideIndex="add-movie" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin/edit-movie/:id">
                  <FormMovie sideIndex="edit-movie" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin/all-movies">
                  <AllMovies />
                </PrivateRoute>

                <PrivateRoute exact path="/admin/add-game">
                  <FormGame sideIndex="add-game" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin/edit-game/:id">
                  <FormGame sideIndex="edit-game" />
                </PrivateRoute>
                <PrivateRoute exact path="/admin/all-games">
                  <AllGames />
                </PrivateRoute>

                <PrivateRoute exact path="/admin/change-password">
                  <ChangePassword />
                </PrivateRoute>

                <Route exact component={NotFound} />
              </Switch>
            </Content>
          </Layout>
        </Layout>
        <Footer
          style={{
            textAlign: "center",
            background: "#001529",
            color: "white",
          }}
        >
          Movie Game Pedia ©2021 Created by{" "}
          <Typography.Link target="_blank" href="https://github.com/nadahasnim">
            Nada Hasni Muhammad
          </Typography.Link>
        </Footer>
      </Layout>
    );
  };

  return (
    <>
      <BrowserRouter>
        {isSideBarActive ? renderPrivateTemplate() : renderPublicTemplate()}
      </BrowserRouter>
    </>
  );
};

export default Routes;
